import styled from 'styled-components';

export default styled.div`
  display: grid;
  grid-template-columns: 50px max-content;
  gap: 0 1rem;
`;
